import React from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { LocationOn } from '@mui/icons-material';

const MAIN_SITE = 'https://cyberwisecorp.com';

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function ScrollLink({ id, children }) {
  return (
    <Link component="button" onClick={() => scrollToSection(id)}
      color="inherit" underline="hover" sx={{ cursor: 'pointer', textAlign: 'left' }}>
      {children}
    </Link>
  );
}

function ExternalLink({ href, children }) {
  return (
    <Link href={href} target="_blank" rel="noopener noreferrer"
      color="inherit" underline="hover">
      {children}
    </Link>
  );
}

function Footer() {
  return (
    <Box component="footer" sx={{ backgroundColor: '#0f172a', color: 'rgba(255,255,255,0.7)', py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Brand + Contact */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ mb: 2 }}>
              <Box component="img" src="/images/cwc-logo-full.png" alt="Cyber Wise Corp"
                sx={{ height: 120, objectFit: 'contain', borderRadius: 1 }} />
            </Box>
            <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.7 }}>
              Get paid to do real cybersecurity work. Expert-supervised assessments with CISSP feedback on every job.
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationOn sx={{ fontSize: 16 }} />
              <Typography variant="body2">Glendale, Arizona</Typography>
            </Box>
          </Grid>

          {/* Program */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>Program</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <ScrollLink id="what-you-do">What You Do</ScrollLink>
              <ScrollLink id="what-you-get">What You Get</ScrollLink>
              <ScrollLink id="earnings">Earnings</ScrollLink>
              <ScrollLink id="application-process">How to Apply</ScrollLink>
              <ScrollLink id="faq">FAQ</ScrollLink>
            </Box>
          </Grid>

          {/* Company */}
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>Company</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <ExternalLink href={`${MAIN_SITE}/about`}>About Us</ExternalLink>
              <ExternalLink href={`${MAIN_SITE}/contact`}>Contact</ExternalLink>
              <ExternalLink href={`${MAIN_SITE}/faq`}>FAQ</ExternalLink>
              <ExternalLink href={`${MAIN_SITE}/colleges`}>Partner Colleges</ExternalLink>
            </Box>
          </Grid>

          {/* Legal */}
          <Grid item xs={6} sm={3} md={3}>
            <Typography variant="subtitle1" sx={{ color: 'white', mb: 2, fontWeight: 700 }}>Legal</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <ExternalLink href={`${MAIN_SITE}/privacy`}>Privacy Policy</ExternalLink>
              <ExternalLink href={`${MAIN_SITE}/terms`}>Terms of Service</ExternalLink>
              <ExternalLink href={`${MAIN_SITE}/code-of-conduct`}>Intern Code of Conduct</ExternalLink>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mt: 4, pt: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="rgba(255,255,255,0.5)">
            &copy; {new Date().getFullYear()} Cyber Wise Corp. All rights reserved. | Glendale, Arizona
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
